export default {
  background: '#f1f1f1',
  accent: '#accfd7',
  color: 'black',
  complementary: '#accfd7',
  clearcolor: '#fffff7',
  fontbody: '"Wide", Helvetica, Arial, sans-serif',
  fonttitle:  '"Title", Helvetica, Arial, sans-serif',
  fonttitle2: '"Title", Helvetica, Arial, sans-serif',
  fonttitle3: '"Title", Helvetica, Arial, sans-serif',
  fonttitlesize: '4rem',
  fontsize: '1.1875rem',
  lineheight: '1.8125rem',
  normalWidth: '680px',
  maxWidth: '1200px',
  overWidth: '1440px',
  button: {
    backgroundColor: '#a21521',
    color: '#fffff7',
    borderRadius: '4px',
    padding: '1rem 2rem'
  }
};